import React from 'react';
import { Box, Typography, Container, Button, Avatar, Divider, Paper, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Contact = () => {
  return (
    <Box
      id="contact"
      component="section"
      sx={{
        py: { xs: 6, md: 9 },
      }}
    >
      <Container maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            overflow: 'hidden',
            borderRadius: { xs: 4, md: 6 },
            backgroundColor: '#fff',
            border: '1px solid rgba(16, 35, 63, 0.08)',
            boxShadow: '0 28px 70px rgba(16, 35, 63, 0.1)',
          }}
        >
          <Box
            sx={{
              p: { xs: 2.5, sm: 4, md: 5 },
              background:
                'linear-gradient(135deg, rgba(20, 50, 92, 1) 0%, rgba(24, 76, 123, 0.97) 55%, rgba(32, 198, 183, 0.88) 100%)',
              color: '#fff',
            }}
          >
            <Typography
              variant="overline"
              sx={{ letterSpacing: '0.16em', fontWeight: 700, color: 'rgba(255,255,255,0.72)' }}
            >
              Contact
            </Typography>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: { xs: '2rem', sm: '2.6rem', md: '3rem' },
                mt: 0.8,
                mb: 1.5,
              }}
            >
              Let’s talk about your next build.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                maxWidth: 640,
                color: 'rgba(255,255,255,0.84)',
                fontSize: { xs: '1rem', md: '1.08rem' },
              }}
            >
              If you need a sharper web presence, AI integration, or a cloud-ready product plan,
              QuantumMind Software can help you move from idea to delivery with less friction.
            </Typography>
          </Box>

          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 3, md: 4 }}
            sx={{ p: { xs: 2.5, sm: 4, md: 5 }, alignItems: { xs: 'flex-start', md: 'center' } }}
          >
            <Stack
              direction="row"
              spacing={2.5}
              sx={{ alignItems: { xs: 'center', md: 'flex-start' }, width: '100%' }}
            >
              <Avatar
                src="Pic.png"
                alt="Director"
                sx={{
                  width: { xs: 88, sm: 104 },
                  height: { xs: 88, sm: 104 },
                  boxShadow: '0 12px 30px rgba(20, 50, 92, 0.18)',
                }}
              />
              <Stack spacing={1.1}>
                <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 800 }}>
                  Heinrich Venter
                </Typography>
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                  Founder / Developer
                </Typography>
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                  <Box component="span" sx={{ fontWeight: 700, color: 'text.primary' }}>
                    Email:
                  </Box>{' '}
                  heinrich.venter@quantummindsoftware.com
                </Typography>
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                  <Box component="span" sx={{ fontWeight: 700, color: 'text.primary' }}>
                    Phone:
                  </Box>{' '}
                  +27 73 192 2566
                </Typography>
              </Stack>
            </Stack>

            <Stack spacing={1.5} sx={{ width: { xs: '100%', md: 'auto' } }}>
              <Button
                component="a"
                href="mailto:heinrich.venter@quantummindsoftware.com"
                variant="contained"
                color="primary"
                sx={{ py: 1.35 }}
              >
                Send an Email
              </Button>
              <Button
                component={RouterLink}
                to="/policy"
                variant="outlined"
                sx={{ py: 1.35 }}
              >
                View GDPR Policy
              </Button>
            </Stack>
          </Stack>

          <Divider />

          <Typography
            variant="body2"
            sx={{
              px: { xs: 2.5, sm: 4, md: 5 },
              py: 2.5,
              color: 'text.secondary',
            }}
          >
            QuantumMind Software PTY (LTD) (2013/146115/07)
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Contact;
